export default __webpack_public_path__ + "static/media/delivery.2234ebe6.svg";